import { apiSlice } from '../api/apiSlice';

export const customerApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCustomers: builder.query({
			query: (urlStr) => `/customers${urlStr}`,
			providesTags: ['customers'],
		}),

		addCustomer: builder.mutation({
			query: (data) => ({
				url: `/customers`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['customers'];
				}
			},
		}),

		showCustomer: builder.query({
			query: ({ id }) => ({
				url: `/customers/${id}`,
			}),
			providesTags: ['showCustomers'],
		}),

		updateCustomer: builder.mutation({
			query: ({ id, data }) => ({
				url: `/customers/${id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['customers'];
				}
			},
		}),

		deleteCustomer: builder.mutation({
			query: (id) => ({
				url: `/customers/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['customers'];
				}
			},
		}),

		changeStatusCustomer: builder.mutation({
			query: ({ id, body }) => ({
				url: `/users/${id}/change-status`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['customers', 'users'];
				}
			},
		}),

		getCustomerSearch: builder.query({
			query: (urlStr) => `/search/customers${urlStr}`,
		}),
		getCustomerIdNext: builder.query({
			query: () => `/customers/next-customer-id`,
		}),
		getStatusOverview: builder.query({
			query: ({ id }) => `/status-overview?customer_id=${id}`,
			keepUnusedDataFor: 600,
		}),
		getInvoiceOverview: builder.query({
			query: ({ id }) => `/invoice-overview?customer_id=${id}`,
			keepUnusedDataFor: 600,
		}),
		addMoreCustomerDocuments: builder.mutation({
			query: ({ id, data }) => ({
				url: `/customers/${id}/add-more-documents`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['showVehicles'];
				}
			},
		}),
		passwordReset: builder.mutation({
			query: ({ id, data }) => ({
				url: `/customers/${id}/change-password`,
				method: 'POST',
				body: data,
			}),
		}),
		getActiveLocation: builder.query({
			query: () => `/active-locations`,
			keepUnusedDataFor: 600,
		}),
		getStatusOverviewWithLocation: builder.query({
			query: (urlStr) => `/status-overview?${urlStr}`,
		}),

		changeCustomerStatus: builder.mutation({
			query: ({ id }) => ({
				url: `/users/${id}/change-password`,
				method: 'POST',
			}),
			invalidatesTags: (result) => {
				if (result) {
					return ['customers'];
				}
			},
		}),

		shippingAgreement: builder.mutation({
			query: (data) => ({
				url: `/customers/shipping-agreement`,
				method: 'POST',
				body: data,
			}),
		}),

		shippingAgreementReject: builder.mutation({
			query: (data) => ({
				url: `/customers/shipping-agreement`,
				method: 'POST',
				body: data,
			}),
		}),


	}),
});

export const {
	useGetCustomersQuery,
	useAddCustomerMutation,
	useAddMoreCustomerDocumentsMutation,
	useShowCustomerQuery,
	useUpdateCustomerMutation,
	useDeleteCustomerMutation,
	useChangeStatusCustomerMutation,
	useGetCustomerSearchQuery,
	useGetCustomerIdNextQuery,
	useGetStatusOverviewQuery,
	useGetActiveLocationQuery,
	useGetStatusOverviewWithLocationQuery,
	useGetInvoiceOverviewQuery,
	usePasswordResetMutation,
	useShippingAgreementMutation,
	useShippingAgreementRejectMutation,
} = customerApi;
